export default __webpack_public_path__ + "static/media/casaduana_networking.79e45837.png";